import { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import AssinaturaInativa from '../paginas/AssinaturaInativa'
import { useAuth } from './AuthProvider'
import { decidirAcesso, type Acesso } from './assinatura'

// Espera maxima pela resposta do banco. Passou disso, libera (ver assinatura.ts):
// rede ruim na rua nao pode trancar o representante do lado de fora.
const ESPERA_MAXIMA_MS = 4000

async function perguntarAoBanco(): Promise<Acesso> {
  const pergunta = supabase.rpc('minha_assinatura').then((r) => decidirAcesso(r as never))
  const desistir = new Promise<Acesso>((resolve) =>
    setTimeout(() => resolve({ situacao: 'liberado' }), ESPERA_MAXIMA_MS),
  )
  try {
    return await Promise.race([pergunta, desistir])
  } catch {
    return { situacao: 'liberado' }
  }
}

export default function RotaProtegida() {
  const { session, carregando } = useAuth()
  const [acesso, setAcesso] = useState<Acesso | null>(null)
  const usuario = session?.user.id

  useEffect(() => {
    if (!usuario) return
    let cancelado = false
    void perguntarAoBanco().then((a) => {
      if (!cancelado) setAcesso(a)
    })
    return () => {
      cancelado = true
      setAcesso(null)
    }
  }, [usuario])

  if (carregando) return <p className="p-6 text-slate-500">Carregando…</p>
  if (!session) return <Navigate to="/login" replace />
  if (!acesso) return <p className="p-6 text-slate-500">Carregando…</p>
  if (acesso.situacao === 'inativo') return <AssinaturaInativa status={acesso.status} />
  return <Outlet />
}
